import React from 'react'
import LayoutRenderTabs from './LayoutRenderTabs'
import { ViewTabTypes } from '../../types/types'

const ViewTab = ({
  layout,
  page,
  layoutList,
  recordId,
  entityId,
  tabIndexMap,
  isPrintLetterView,
  isWorkflow,
}: ViewTabTypes) => {
  const pageId = page?.pageId
  const meta = layout?.layout_data?.tab_info?.[pageId]

  return page?.rows?.map((row, _index) => {
    return (
      <div key={row?.rowId} className="w-full">
        <LayoutRenderTabs
          row={row}
          meta={meta || {}}
          layoutList={layoutList}
          parentLayout={layout}
          recordId={recordId}
          entityId={entityId}
          tabIndexMap={
            row?.rowId && tabIndexMap ? tabIndexMap?.[row?.rowId] : undefined
          }
          isPrintLetterView={isPrintLetterView}
          isWorkflow={isWorkflow}
        />
      </div>
    )
  })
}

export default ViewTab
